  <div data-testid="dashboard-table-datagrid-headers" class="dx-datagrid-headers" style="padding-top: 10px; padding-left: 10px; font-size: 1.0rem; font-weight: bold;">{{title}}</div>
  <dx-data-grid data-testid="dashboard-table-data-grid"
    #dxDataGrid
    [dataSource]="data"
    [showBorders]="true"
    [columnAutoWidth]="columnAutoWidth"
    [wordWrapEnabled]="false"
    [rowAlternationEnabled]="true"
    [allowColumnResizing]="allowColumnResizing"
    [columnResizingMode]="columnResizingMode"
    (onCellClick)="onCellClick($event)"
    (onContentReady)="onGridContentReady()"
  >
    <dxo-paging [pageSize]="10"></dxo-paging>

    <dxi-column *ngFor="let col of columns; let i = index"
                [dataField]="col.dataField"
                [caption]="col.caption"
                [cellTemplate]="col.cellTemplate || null"
                [headerCellTemplate]="getHeaderTemplate(col.dataField)"
                [visible]="col.visible"
                [sortIndex]="i === 0 ? 0 : null"
                [sortOrder]="i === 0 ? 'asc' : null"
                [width]="getColumnWidth(i)"
                [minWidth]="getColumnMinWidth(i)"
            >
    </dxi-column>

    <div *dxTemplate="let cellData of 'clickableCell'">
      <div
      [class.clickable-cell]="cellData.value !== 0"
      [title]="getCellToolTip(cellData)">
      {{ cellData.value }}
      </div>
    </div>

    <!-- Header templates for status columns -->
    <div *dxTemplate="let headerData of 'openHeader'">
      <span class="status-header-pill status-open-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'pendingHeader'">
      <span class="status-header-pill status-pending-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'holdHeader'">
      <span class="status-header-pill status-hold-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'overdueHeader'">
      <span class="status-header-pill status-overdue-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'rejectedHeader'">
      <span class="status-header-pill status-rejected-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'completedHeader'">
      <span class="status-header-pill status-completed-header">{{ headerData.column.caption }}</span>
    </div>

    <div *dxTemplate="let headerData of 'cancelledHeader'">
      <span class="status-header-pill status-cancelled-header">{{ headerData.column.caption }}</span>
    </div>

  </dx-data-grid>

